// Dongtan's full-art maps contain the existing 1800x1280 coordinate plane.
// These windows were measured against the original floor maps in the local design preview.
const DONGTAN_WINDOWS = {
  4: { source: 'cc26ab98622f4a45a28b4f116cd838c8.webp', x: 1168, y: 1884, scale: 0.965 },
  5: { source: '680c3dda8da544eb8733671faae07500.webp', x: 1148, y: 1852, scale: 1 },
};

export function alignHeadquartersMap(art, coordinateMap, storeId) {
  const floor = Number(art?.floor ?? art?.floor_key?.replace(/f$/i, ''));
  const window = DONGTAN_WINDOWS[floor];
  const width = Number(art?.width);
  const height = Number(art?.height);
  // Upload optimization keeps aspect ratio but limits the longest edge to 3000px.
  // Permit one pixel of rounding; retain the known store/floor/source-map guards.
  const sameArtworkRatio = Number.isFinite(width) && Number.isFinite(height)
    && width > 0 && height > 0 && Math.abs(width - height * 4096 / 4950) <= 1;
  if (String(storeId) !== '3' || !window
    || !sameArtworkRatio
    || Number(coordinateMap?.width) !== 1800 || Number(coordinateMap?.height) !== 1280
    || !String(coordinateMap?.image_url || '').split('?')[0].endsWith('/' + window.source)) return art;
  const displayWindow = DONGTAN_WINDOWS[4]; // Both floors share the same forest artwork framing.
  const scaleX = width / 4096;
  const scaleY = height / 4950;
  return {
    ...art,
    width: 1800, height: 1280,
    pinTransform: {
      x: (window.x - displayWindow.x) / (1800 * displayWindow.scale),
      y: (window.y - displayWindow.y) / (1280 * displayWindow.scale),
      scale: window.scale / displayWindow.scale,
    },
    imageWindow: {
      x: displayWindow.x * scaleX, y: displayWindow.y * scaleY,
      width: 1800 * displayWindow.scale * scaleX, height: 1280 * displayWindow.scale * scaleY,
      sourceWidth: width, sourceHeight: height,
    },
  };
}

export function headquartersMapImageStyle(map) {
  const frame = map?.imageWindow;
  if (!frame) return undefined;
  return {
    position: 'absolute', maxWidth: 'none',
    width: `${frame.sourceWidth / frame.width * 100}%`, height: `${frame.sourceHeight / frame.height * 100}%`,
    left: `${-frame.x / frame.width * 100}%`, top: `${-frame.y / frame.height * 100}%`,
    maskImage: 'none', WebkitMaskImage: 'none',
  };
}

// Reproject floor-map coordinates onto the shared artwork frame; preserve missing pins.
export function headquartersMapPoint(map, x, y) {
  const transform = map?.pinTransform;
  if (!transform) return { x, y };
  return {
    x: x == null ? x : transform.x + x * transform.scale,
    y: y == null ? y : transform.y + y * transform.scale,
  };
}
